import Toast from 'vant/lib/toast';
import 'vant/lib/toast/style';

export default {
  /**
   * Toast 自动消失提示浮层
   * @param text 内容
   * @param position 位置 top | middle | bottom
   * @param duration 消失时间，毫秒
   */
  toast: Toast,
  /**
   * loading 加载浮层
   * @function: show 显示浮层
   * @function: hide 隐藏浮层
   */
  loading: {
    show(text) {
      Toast.loading({
        forbidClick: true,
        duration: 0,
        message: text || '正在加载',
      });
    },
    hide() {
      Toast.clear();
    },
  },

};
